<template>
  <div id="Admin_Payment_review">
    <!-- 收費項目審核 -->
    <div
      id="areview"
      class="tab-pane fade show active"
      role="tabpanel"
      aria-labelledby="apr"
    >
      <div class="col-12 pt-2 table-style">
        <!-- 功能欄 -->
        <v-query-layout>
          <!-- 1 -->
          <v-label
            slot="ql1-text-1"
            LabText="篩選資料："
            Labbold="true"
          />
          <input
            class="input-style"
            type="text"
            slot="ql1-input-1"
            placeholder="請輸入關鍵字"
            v-model="filter"
          >
          <v-label
            v-if="Backend"
            slot="ql1-text-2"
            class="ml-2 mt-1"
            LabText="選擇單位："
            Labbold="true"
          />
          <v-Dept
            v-if="Backend"
            slot="ql1-input-2"
            style="width: 290px;"
            :DeptData="NewDeptId"
            @SelectDept="SelectDept"
          />
          <!-- 2 -->
          <v-label
            slot="ql2-text-1"
            LabText="收費項目編號："
            Labbold="true"
          />
          <input
            class="input-style"
            type="text"
            slot="ql2-input-1"
            v-model="RFeeItemId"
          >
          <div slot="ql2-input-2">
            <v-button
              btn-text="查詢"
              btnOutline="primary"
              @click.native="InquireFeeitemQuery"
            >
              <font-awesome-icon
                slot="icon"
                icon="search"
              />
            </v-button>
            <v-button
              class="ml-2"
              btn-text="清除"
              btnOutline="secondary"
              @click.native="ClearCondition"
            >
              <font-awesome-icon
                slot="icon"
                icon="search-minus"
              />
            </v-button>
          </div>
          <!-- 3 -->
          <v-label
            slot="ql3-text-1"
            LabText="收費項目："
            Labbold="true"
          />
          <v-button
            slot="ql3-input-1"
            btn-text="申請"
            title="收費項目申請表"
            btnType="primary"
            @click.native="PostApplyData"
          >
            <font-awesome-icon
              slot="icon"
              icon="edit"
              size="sm"
            />
          </v-button>
          <v-label
            slot="ql3-text-2"
            class="ml-2"
            LabText="筆數："
            Labbold="true"
          />
          <v-page
            slot="ql3-input-2"
            @RecPerPage="RecPerPage"
          />
        </v-query-layout>
        <hr>
        <!-- 表格資料 -->
        <template>
          <b-table
            id="b-table-small"
            hover
            small
            bordered
            show-empty
            responsive
            empty-text="目前無資料"
            style="position: relative;"
            :items="items"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            @filtered="onFiltered"
          >
            <!-- 單位 -->
            <template v-slot:cell(ApplyDeptId)="data">
              <div
                v-for="DeptIds in AllDeptData"
                :key="DeptIds.id"
                :value="DeptIds.DeptId"
              >
                <div v-if="data.item.ApplyDeptId == DeptIds.DeptId">
                  {{ DeptIds.DeptName }}
                </div>
              </div>
            </template>
            <!-- 收費項目類型(判斷) -->
            <template v-slot:cell(FeeItemType)="data">
              <span v-if="data.item.FeeItemType === 1">
                公開項目
              </span>
              <span v-else>
                個人項目
              </span>
            </template>
            <!-- 收費項目金額 -->
            <template v-slot:cell(FeeItemValue)="data">
              {{ data.item.FeeItemValue + ' 元' }}
            </template>
            <!-- 審核狀態(判斷) -->
            <template v-slot:cell(CurrentType)="data">
              <span v-if="data.item.CurrentType === 0" style="color: crimson;">
                審核不通過
              </span>
              <span v-else-if="data.item.CurrentType === 1">
                審核通過
              </span>
              <span v-else>
                審核中
              </span>
            </template>
            <!-- 功能 -->
            <template v-slot:cell(Actions)="data">
              <v-button
                btn-text="變更"
                title="申請變更"
                btnSize="sm"
                btnType="primary"
                @click.native="PostModifyData(data.item)"
              />
              <v-button
                class="ml-1"
                btn-text="詳細"
                title="詳細資料"
                btnSize="sm"
                btnType="warning"
                @click.native="PostDetailed(data.item)"
              />
              <!-- 條件: 1.[審核通過]以外的 2.管理者 -->
              <v-button
                class="ml-1"
                btn-text="審核"
                title="審核收費項目"
                btnSize="sm"
                btnType="info"
                v-if="data.item.CurrentType !== 1 && Backend"
                @click.native="PostDataReview(data.item)"
              />
              <!-- 條件: 1.除[審核中]以外的 -->
              <v-button
                class="ml-1"
                btn-text="刪除"
                title="刪除收費項目"
                btnSize="sm"
                btnType="danger"
                v-if="data.item.CurrentType !== 255 && Backend"
                @click.native="CheckFeeitemDelete(data.item)"
              />
              <!-- 條件: 1.[審核中] -->
              <v-button
                class="ml-1"
                btn-text="列印"
                title="列印申請收費項目表"
                btnSize="sm"
                btnOutline="secondary"
                v-if="data.item.CurrentType === 255"
                @click.native="PostDataPrint(data.item)"
              />
            </template>
          </b-table>
          <!-- 分頁 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          />
        </template>
        <br>
      </div>
    </div>
    <!-- 詳細資料 -->
    <v-modal id="dataile">
      <div slot="header">
        {{ Datailed.FeeItemName }}-詳細資料
      </div>
      <div slot="body">
        <span id="Payment_Review_Table"></span>
        <table
          class="table table-bordered table-hover receipt-table white-color"
          aria-describedby="Payment_Review_Table"
        >
          <tbody>
            <tr>
              <th scope="col">
                申請人員職編
              </th>
              <td>{{ Datailed.ApplyStaffId }}</td>
            </tr>
            <tr>
              <th scope="col">申請(變更)人員姓名</th>
              <td>{{ Datailed.ApplyStaffName }}</td>
            </tr>
            <tr>
              <th scope="col">申請(變更)時間</th>
              <td>{{ Datailed.ApplyDT }}</td>
            </tr>
            <tr>
              <th scope="col">申請單位</th>
              <td>{{ Datailed.ApplyDeptName }}</td>
            </tr>
            <tr>
              <th scope="col">收費項目名稱</th>
              <td>{{ Datailed.FeeItemName }}</td>
            </tr>
            <tr>
              <th scope="col">收費項目編號</th>
              <td>{{ Datailed.FeeItemId }}</td>
            </tr>
            <tr>
              <th scope="col">收費項目類型</th>
              <td v-if="Datailed.FeeItemType === 1">
                公開項目
              </td>
              <td v-else>
                個人項目
              </td>
            </tr>
            <tr>
              <th scope="col">收費項目金額屬性</th>
              <td v-if="Datailed.FeeValueType === 1">
                固定金額
              </td>
              <td v-else>
                非固定金額
              </td>
            </tr>
            <tr>
              <th scope="col">收費項目金額</th>
              <td>{{ Datailed.FeeItemValue }}</td>
            </tr>
            <tr>
              <th scope="col">繳費期限類型</th>
              <td v-if="Datailed.PayDeadline === 1">
                依繳費期限
              </td>
              <td v-else>
                無期限，持續性收款
              </td>
            </tr>
            <tr>
              <th scope="col">繳費期限起始</th>
              <td>{{ Datailed.PayDateBegin }}</td>
            </tr>
            <tr>
              <th scope="col">繳費期限截止</th>
              <td>{{ Datailed.PayDateEnd }}</td>
            </tr>
            <tr>
              <th scope="col">繳費通路種類</th>
              <td>{{ Datailed.PayCategory }}</td>
            </tr>
            <tr>
              <th scope="col">會計科目</th>
              <td>{{ Datailed.AccountingTitle }}</td>
            </tr>
            <tr>
              <th scope="col">計畫編號</th>
              <td>{{ Datailed.ProjectNumber }}</td>
            </tr>
            <tr>
              <th scope="col">是否由串接系統建立繳費項目</th>
              <td v-if="Datailed.IsIntegrated === 0">
                否
              </td>
              <td v-else>
                是
              </td>
            </tr>
            <tr>
              <th scope="col">串接之異質系統代碼</th>
              <td>{{ Datailed.IntegratedSysId }}</td>
            </tr>
            <tr>
              <th scope="col">收費項目狀態</th>
              <td v-if="Datailed.CurrentType === 0">
                審核不通過
              </td>
              <td v-else-if="Datailed.CurrentType === 1">
                審核通過
              </td>
              <td v-else>
                審核中
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div slot="footer">
        <v-button
          btn-text="確認"
          btnType="primary"
          data-dismiss="modal"
        />
      </div>
    </v-modal>
    <!-- 刪除Modal -->
    <v-modal id="Delete">
      <div slot="header">
        刪除收費項目
      </div>
      <div slot="body">
        確認是否刪除「{{ DeleteName }}」
        <br>
        <span class="small-color">
          *刪除提醒-已有繳款項目者，不能刪除
        </span>
      </div>
      <div slot="footer">
        <v-button
          btn-text="確認"
          btnType="primary"
          @click.native="PostFeeitemDelete"
        />
        <v-button
          class="ml-1"
          btn-text="取消"
          btnType="secondary"
          data-dismiss="modal"
          aria-label="Close"
        />
      </div>
    </v-modal>
  </div>
</template>

<script>
import md5 from 'js-md5'
import $ from 'jquery'
import vModal from '@/components/Features/ModalFloot'
import vQueryLayout from '@/components/Layout/QueryLayout'
import { apiFeeitemQuery, apiFeeitemDelete } from '../../../Api/api'
import { fillcompile } from '../../../Api/compile'

export default {
  name: 'admin-review',
  components: {
    'v-modal': vModal,
    'v-query-layout': vQueryLayout
  },
  data () {
    return {
      items: [],
      fields: [
        { key: 'SerialNo', label: '#', stickyColumn: true, isRowHeader: true, thClass: 'table-th', variant: 'info', sortable: true },
        { key: 'FeeItemId', label: '收費項目編號', thClass: 'table-th', sortable: true },
        { key: 'FeeItemName', label: '收費項目名稱', thClass: 'table-th', sortable: true },
        { key: 'ApplyDeptId', label: '單位', thClass: 'table-th', sortable: true },
        { key: 'FeeItemType', label: '收費項目類型', thClass: 'table-th', sortable: true },
        { key: 'FeeItemValue', label: '收費項目金額', thClass: 'table-th', sortable: true, variant: 'warning' },
        { key: 'PayDateBegin', label: '起始日', thClass: 'table-th', sortable: true },
        { key: 'PayDateEnd', label: '截止日', thClass: 'table-th', sortable: true },
        { key: 'CurrentType', label: '審核狀態', thClass: 'table-th', sortable: true },
        { key: 'Actions', label: '功能', thClass: 'table-th' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filter: null,
      Datailed: {},
      ApplyDeptId: '',
      AllDeptData: [],
      NewDeptId: sessionStorage.getItem('ReviewDeptID') ? JSON.parse(sessionStorage.getItem('ReviewDeptID')) : '',
      RFeeItemId: '',
      CheckId: '',
      CheckName: '',
      CheckAccountingTitle: '',
      CheckProjectNumber: '',
      DeleteId: '',
      DeleteName: '',
      Backend: false,
      QueryData: {},
      errfunction: 0
    }
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    this.PostFeeitemQuery()
    this.CheckQueryDept()
  },
  created () { // 從Dept組件接收部門資料
    this.$bus.$on('AllDept', (data) => {
      this.AllDepts(data)
    })
  },
  methods: {
    AllDepts (data) { // 從Dept組件取得部門資料
      if (this.errfunction === 0) {
        // 從子層取得部門資料
        // 但function會以讀取頁面第1、2、3次的形式遞增多跑
        // 目前無法發現是何種原因造成
        // 先以errfunction變數阻擋遞增，待解決
        this.AllDeptData = data
        this.errfunction = 1
      }
    },
    SelectDept (vDeptId) { // 組件-部門
      this.NewDeptId = vDeptId
      sessionStorage.setItem('ReviewDeptID', JSON.stringify(vDeptId))
    },
    RecPerPage (SublayerPage) { // 組件筆數
      this.perPage = SublayerPage
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    PostFeeitemQuery () { // 查詢 B_API 008
      const vm = this
      var NewData
      // API預設資料
      const IdentityData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      // 查詢條件
      const ReviewQuery = JSON.parse(sessionStorage.getItem('ReviewQuery'))
      const Backend = md5('管理者')
      if (Backend === sessionStorage.getItem('Backend')) { // 管理者
        vm.Backend = true
        if (!ReviewQuery) { // No QueryData
          UserData.ApplyDeptId = vm.ApplyDeptId
          UserData.FeeItemId = vm.RFeeItemId
          NewData = Object.assign(IdentityData, UserData)
        } else {
          vm.ApplyDeptId = ReviewQuery.ApplyDeptId
          vm.RFeeItemId = ReviewQuery.FeeItemId
          NewData = Object.assign(IdentityData, ReviewQuery)
        }
      } else { // 業務
        if (!ReviewQuery) { // No QueryData
          vm.ApplyDeptId = UserData.DeptId
          vm.QueryData = {}
          vm.QueryData.DeptId = UserData.DeptId
          vm.QueryData.ApplyDeptId = UserData.DeptId
          vm.QueryData.FeeItemId = vm.RFeeItemId
          sessionStorage.setItem('ReviewQuery', JSON.stringify(vm.QueryData))
          NewData = Object.assign(IdentityData, vm.QueryData)
        } else {
          vm.RFeeItemId = ReviewQuery.FeeItemId
          NewData = Object.assign(IdentityData, ReviewQuery)
        }
      }
      // 呼叫API
      apiFeeitemQuery(NewData).then(
        res => {
          if (res !== undefined) {
            for (let i = 0; i < res.Data.length; i++) {
              const json = res.Data[i]
              json.SerialNo = i + 1
            }
            vm.items = res.Data
            vm.totalRows = res.Data.length
          }
        }
      )
    },
    InquireFeeitemQuery () { // 查詢條件
      // 定義資料
      const vm = this
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      NewData.FeeItemId = vm.RFeeItemId
      // 判斷身分，區分單位
      if (vm.Backend) {
        if (vm.NewDeptId) {
          vm.ApplyDeptId = vm.NewDeptId.DeptId
        }
        NewData.ApplyDeptId = vm.ApplyDeptId
      } else {
        vm.ApplyDeptId = UserData.DeptId
        NewData.ApplyDeptId = vm.ApplyDeptId
      }
      NewData.DeptId = UserData.DeptId
      // 紀錄查詢條件
      const QueryData = {}
      QueryData.DeptId = UserData.DeptId
      QueryData.ApplyDeptId = vm.ApplyDeptId
      QueryData.FeeItemId = vm.RFeeItemId
      sessionStorage.setItem('ReviewQuery', JSON.stringify(QueryData))
      // 呼叫API
      apiFeeitemQuery(NewData).then(
        res => {
          if (res !== undefined) {
            for (let i = 0; i < res.Data.length; i++) {
              const json = res.Data[i]
              json.SerialNo = i + 1
            }
            vm.items = res.Data
            vm.totalRows = res.Data.length
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostApplyData () { // 申請收費項目
      this.$router.push({
        name: 'Admin_Application', params: { type: 'apply' }
      })
    },
    ClearCondition () { // 清除查詢條件
      const vm = this
      sessionStorage.removeItem('ReviewQuery')
      sessionStorage.removeItem('ReviewDeptID')
      vm.ApplyDeptId = ''
      vm.NewDeptId = ''
      vm.RFeeItemId = ''
      vm.filter = ''
      vm.PostFeeitemQuery()
    },
    PostDetailed (data) { // 準備申請變更資料
      this.Datailed = data
      this.Datailed.PayCategory = fillcompile(data.PayCategory)
      $('#dataile').modal('show')
    },
    PostModifyData (data) { // 導向申請變更頁面
      const App = data.ApplyDeptId
      const Fee = data.FeeItemId
      this.$router.push({
        name: 'Admin_Application_Edit', params: { app: App, fee: Fee, type: 'change' }
      })
    },
    PostDataPrint (data) { // 列印申請項目審核表
      const App = data.ApplyDeptId
      const Fee = data.FeeItemId
      this.$router.push({
        name: 'Admin_Application_Edit', params: { app: App, fee: Fee, type: 'Print' }
      })
    },
    PostDataReview (data) { // 審核申請項目表
      const App = data.ApplyDeptId
      const Fee = data.FeeItemId
      this.$router.push({
        name: 'Admin_Application_Edit', params: { app: App, fee: Fee, type: 'Review' }
      })
    },
    CheckFeeitemDelete (data) { // 準備刪除收費項目
      this.DeleteId = data.FeeItemId
      this.DeleteName = data.FeeItemName
      $('#Delete').modal('show')
    },
    PostFeeitemDelete () { // 刪除 B_API024
      // 定義資料
      const vm = this
      $('#Delete').modal('hide')
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.FeeItemId = vm.DeleteId
      // 呼叫API
      apiFeeitemDelete(NewData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Modals', res.Msg)
            $('#CheckOk').modal('show')
            vm.PostFeeitemQuery()
          }
        }
      )
    },
    CheckQueryDept () { // 未查詢選擇部門時
      if (this.ApplyDeptId === '') {
        this.NewDeptId = ''
      }
    }
  }
}
</script>
